import { Suspense } from 'react'

import { Outlet } from '@tanstack/react-router'
import { CircularProgress } from 'ui/components'

export const BankDocumentsWrapper = () => (
  <Suspense fallback={<CircularProgress centered />}>
    <Outlet />
  </Suspense>
)
